import { format, parseISO, isSameDay } from "date-fns"

export function formatDate(startString: string, endString: string | null = null, allDay = false): string {
	const start = parseISO(startString)

	if (allDay) {
		if (endString === null || isSameDay(start, parseISO(endString))) {
			return format(start, "MMMM d, yyyy")
		}

		return `${format(start, "MMMM d, yyyy")} – ${format(parseISO(endString), "MMMM d, yyyy")}`
	}

	if (endString === null) {
		return format(start, "MMMM d, yyyy 'at' h:mm a")
	}

	const end = parseISO(endString)

	if (isSameDay(start, end)) {
		return `${format(start, "MMMM d, yyyy")} ${format(start, "h:mm a")}–${format(end, "h:mm a")}`
	}

	return `${format(start, "MMMM d, yyyy h:mm a")} – ${format(end, "MMMM d, yyyy h:mm a")}`
}
